import { render, staticRenderFns } from "./ItemSetting.vue?vue&type=template&id=7de378f9&"
import script from "./ItemSetting.vue?vue&type=script&lang=js&"
export * from "./ItemSetting.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

component.options.__file = "ItemSetting.vue"
export default component.exports